<div class="layui-collapse" lay-accordion="">
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">如何解禁被封账号？</h2>
    <div class="layui-colla-content layui-show">
      本平台账号一经被封，不可自动解禁，如对官方封号行为存疑，可联系客服咨询。
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">如何注销账户？</h2>
    <div class="layui-colla-content">
      联系客服提交账号注销申请，清除账户资料及解除手机绑定等。
    </div>
  </div>
  <div class="layui-colla-item">
    <h2 class="layui-colla-title">为什么会被封号？</h2>
    <div class="layui-colla-content">
      <p>凡在平台上存在涉黄涉政言论、存在扰乱平台正常运营秩序的行为、存在欺诈诱骗（如加私下交易微信转账、发红包、借钱等）、恶意散播广告挖人等行为。</p>
    </div>
  </div>
</div>